var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7856 3.88789e-08H1.21336C0.543152 0.000335732 -0.000167808 0.543991 3.88789e-08 1.21437V20.7866C0.000335732 21.4568 0.543991 22.0002 1.21437 22H20.7856C21.4562 22.0002 21.9998 21.4567 22 20.7861C22 20.786 22 20.7858 22 20.7856V1.21336C21.9997 0.543152 21.456 -0.000167808 20.7856 3.88789e-08Z",
    fill: "#4267B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1895 21.9997V13.4919H18.0576L18.4873 10.1618H15.1895V8.04094C15.1895 7.07901 15.4565 6.42357 16.8359 6.42357H18.584V3.45319C18.2798 3.41273 17.2363 3.32227 16.0221 3.32227C13.487 3.32227 11.752 4.86914 11.752 7.71112V10.1618H8.89453V13.4919H11.752V21.9997H15.1895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.86bcee89cdf8b18ccdb364fc0bb7e4fd.svg";
export { ForwardRef as ReactComponent };